<div class="orange-content">
  <div class="siga fw-bold d-flex flex-column">
    <div>SIGA</div>
  </div>
  <div class="siga-user-information">
    <mat-icon class="account-icon">
      account_circle
    </mat-icon>
    <div class="u-information" *ngIf="name && lastName && email">
      <div>
        {{ name }} {{ lastName }}
      </div>
      <div>
        {{ email }}
      </div>
    </div>
  </div>
</div>
<form [formGroup]="form" class="p-2 pt-3 d-flex justify-content-center align-items-center">
  <mat-form-field appearance="outline" class="custom-field">
    <mat-label>Canal</mat-label>
    <mat-select formControlName="channel" (selectionChange)="selectChannel($event)">
      <mat-option value="CNP">Canales No Presenciales (CNP)</mat-option>
      <mat-option value="CP">Canales Presenciales (CP)</mat-option>
      <mat-option value="WHATSAPP">Canal WhatsApp</mat-option>
    </mat-select>
  </mat-form-field>
</form>
<div class="white-content nav-left-site">
  <button class="item-left-site" routerLink="/pv/request-day"><mat-icon>dashboard</mat-icon>RESUMEN</button>
  <button class="item-left-site" routerLink="/pv/tracing"
    *ngIf="form.get('channel').value == 'CNP' || form.get('channel').value == 'WHATSAPP'"><mat-icon>timeline</mat-icon>SEGUIMIENTO</button>
  <button class="item-left-site dropdown" [matMenuTriggerFor]="menu"><mat-icon>search</mat-icon>CONSULTAS</button>
  <mat-menu #menu="matMenu" xPosition="before">
    <button mat-menu-item routerLink="/pv/customer-consultation">Consultar por cliente</button>
    <button mat-menu-item routerLink="/pv/monthly-weekly-consultation">Consultar por rango</button>
  </mat-menu>
  <button class="item-left-site" routerLink="/pv/year-month-report"
    *ngIf="roleModerator || roleAdmin || roleUserReports"><mat-icon>playlist_add_check</mat-icon>REPORTES</button>
  <!--<button class="item-left-site dropdown" [matMenuTriggerFor]="menuGestion"
    *ngIf="form.get('channel').value == 'CNP' && (roleModerator || roleAdmin)">
    <mat-icon>picture_as_pdf</mat-icon>GESTIÓN DE DOCUMENTOS
  </button>
  <mat-menu #menuGestion="matMenu" xPosition="before">
    <button mat-menu-item class="item-left-site dropdown" [matMenuTriggerFor]="menuPlantillas"> Plantillas</button>
    <button mat-menu-item class="item-left-site dropdown" [matMenuTriggerFor]="menuTiposDeVenta">Tipos de venta</button>
    <mat-menu #menuPlantillas="matMenu" xPosition="after">
      <button mat-menu-item routerLink="/pv/checkout-template">Ver plantilla</button>
      <button mat-menu-item routerLink="/pv/manage-template">Gestionar plantilla</button>
      <button mat-menu-item routerLink="/pv/template-versions">Control de versiones plantillas</button>
    </mat-menu>
    <mat-menu #menuTiposDeVenta="matMenu" xPosition="after">
      <button mat-menu-item routerLink="/pv/checkout-sale-kind">Ver tipo de venta</button>
      <button mat-menu-item routerLink="/pv/manage-sale-kind">Gestionar tipo de venta</button>
      <button mat-menu-item routerLink="/pv/sale-kind-versions">Control de versiones tipos de venta</button>
    </mat-menu>
  </mat-menu>-->
  <button class="item-left-site dropdown" [matMenuTriggerFor]="menuGestionUsuarios" *ngIf="roleAdmin">
    <mat-icon>settings</mat-icon>GESTIÓN DE USUARIOS
  </button>
  <mat-menu #menuGestionUsuarios="matMenu" xPosition="before">
    <button mat-menu-item routerLink="/pv/sign-up">Crear usuario</button>
    <button mat-menu-item routerLink="/pv/user-list">Lista de usuarios</button>
  </mat-menu>
</div>